import Ajax from './ajax';
import { jsToFormData } from "@/utils/func";

// 登陆
export const login = (data) => Ajax.post('/fs-accountLogin', jsToFormData(data));
export const getCode = (data) => Ajax.post(`/fs-send-code`, jsToFormData(data), false);//获取验证码
export const getCheckAuthStatus = (data) => Ajax.post(`/fs-user-index-checkAuthStatus`, jsToFormData(data), false);//获取验证码
export const verifyCode = (data) => Ajax.post(`/fs-user-ver-code`, jsToFormData(data));//验证码校验
export const loginOut = (data) => Ajax.post(`/fs-login-out`, jsToFormData(data));//退出登录
export const esingCreateSignFlow = (data) => Ajax.post(`/fs-esing-create-sign-flow`, jsToFormData(data));//退出登录
// export const v1MobileLogin = (data) => Ajax.post(`/fs-mobile-login`, jsToFormData(data));
export const v1MobileLogin = (data) => Ajax.post(`/fs-codeLogin`, jsToFormData(data));
export const studentUpdatePwd = (data) => Ajax.post(`/fs-user-reset-pass`, jsToFormData(data));//修改密码
export const forgetPwd = (data) => Ajax.post(`/fs-user-forget-pass`, jsToFormData(data));//忘记密码
export const userUpPwd = (data) => Ajax.post(`/fs-user-up-pwd`, jsToFormData(data));//修改密码

// 实践考核登录
export const pracLogin = (data) => Ajax.post('/v1-own-student-prac-login', jsToFormData(data));

// 告知书页面
export const patch = () => Ajax.get(`/fs-patch`, null); //获取告知书
export const studentNotification = () => Ajax.post(`/fs-student-notification`, null); // 告知书确认

// 确认信息-成教
export const adultStudentEnterConfirm = () => Ajax.post(`/v1-adult-student-enter-confirm`, null); //确认录取信息
export const adultStudentGetEnter = () => Ajax.get(`/v1-adult-student-get-enter`, null); //获取录取信息

// 上传入学照-成教
export const adultStudentUserEnterImg = data => Ajax.post(`/v1-adult-student-user-enter-img`, jsToFormData(data));  //上传入学照
export const adultStudentUserGetEnterImg = data => Ajax.get(`/v1-adult-student-user-get-enter-img`, jsToFormData(data));  //获取入学照最后一条审核记录

export const codeServe = {
  qrcode: (data) => Ajax.post('/fs-wechat-auth-qrcode', jsToFormData(data), false),
  isLogin: (data) => Ajax.post('/fs-scan-code-login', jsToFormData(data)),
  qrcodeBind: data => Ajax.post('/fs-user-bind-wechat', jsToFormData(data), false),
  qrcodeDelBind: data => Ajax.post('/fs-user-unbind-wechat', jsToFormData(data)),
}
